import { defineComponent, onMounted, ref } from 'vue';
import styles from './index.module.scss';
import {
  FormRules,
  NButton,
  NCard,
  NForm,
  NFormItem,
  NInput,
  NModal,
  NRadioButton,
  NRadioGroup,
  NRate,
  NUpload,
  UploadFileInfo,
  useMessage,
  NAnchor,
  NEllipsis,
} from 'naive-ui';
import Typography from '@/components/TextFormat/FormatElements/Typography';
import { SettledFileInfo } from 'naive-ui/es/upload/src/interface';
import { useStore } from 'vuex';
import webConfig from '@dts/shared/src/utils/httpUrlConfig';
import SVG from '@dts/shared/src/assets/svg';
import Anchor from './components/Anchor/index.vue';
import { throttle } from '@/utils/baseTool';

const props = {
  show: {
    type: Boolean,
    require: true,
  },
};
const isLoadingFanish = ref(true);
const Glossary = defineComponent({
  emits: ['update:show'],
  setup: (props, { attrs, emit }) => {
    const glossaryList = ref<any>({});
    const keyword = ref<string>('');
    const getGlossaryList = () => {
      isLoadingFanish.value = false;
      // glossaryList.value = [
      //   {
      //     letter: 'A',
      //     children: [
      //       {
      //         name: 'abandon',
      //         desc: '放弃，英语词汇第一个单词，。。。。。。',
      //       },
      //       {
      //         name: 'Apple',
      //         desc: '苹果是一种手机，也可以是一种蔬果',
      //       },
      //       {
      //         name: 'Apple',
      //         desc: '苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果',
      //       },
      //       {
      //         name: 'Apple',
      //         desc: '苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果',
      //       },
      //       {
      //         name: 'Apple',
      //         desc: '苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果',
      //       },
      //       {
      //         name: 'Apple',
      //         desc: '苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果,苹果是一种手机，也可以是一种蔬果',
      //       },
      //     ],
      //   },
      //   {
      //     letter: 'B',
      //     children: [
      //       {
      //         name: 'banana',
      //         desc: '香蕉，马楼爱吃香蕉',
      //       },
      //     ],
      //   },
      //   {
      //     letter: 'C',
      //     children: [
      //       {
      //         name: 'city',
      //         desc: '城市',
      //       },
      //       {
      //         name: 'clothes',
      //         desc: '衣服',
      //       },
      //     ],
      //   },
      //   {
      //     letter: 'D',
      //     children: [
      //       {
      //         name: 'dad',
      //         desc: '爸爸的爸爸叫爷爷',
      //       },
      //     ],
      //   },
      //   {
      //     letter: 'M',
      //     children: [
      //       {
      //         name: 'Malou',
      //         desc: '马楼，一种神奇的生物',
      //       },
      //     ],
      //   },
      //   {
      //     letter: 'N',
      //     children: [
      //       {
      //         name: 'new',
      //         desc: '新的一天就从敲代码开始',
      //       },
      //     ],
      //   },
      //   {
      //     letter: 'P',
      //     children: [
      //       {
      //         name: 'p',
      //         desc: '动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家',
      //       },
      //       {
      //         name: 'p',
      //         desc: '动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家',
      //       },
      //       {
      //         name: 'p',
      //         desc: '动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家',
      //       },
      //       {
      //         name: 'p',
      //         desc: '动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家',
      //       },
      //       {
      //         name: 'p',
      //         desc: '动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家',
      //       },
      //       {
      //         name: 'p',
      //         desc: '动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家',
      //       },
      //       {
      //         name: 'p',
      //         desc: '动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家',
      //       },
      //     ],
      //   },
      //   {
      //     letter: 'Q',
      //     children: [
      //       {
      //         name: 'p',
      //         desc: '动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家',
      //       },
      //       {
      //         name: 'p',
      //         desc: '动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家',
      //       },
      //       {
      //         name: 'p',
      //         desc: '动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家',
      //       },
      //       {
      //         name: 'p',
      //         desc: '动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家',
      //       },
      //       {
      //         name: 'p',
      //         desc: '动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家',
      //       },
      //       {
      //         name: 'p',
      //         desc: '动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家',
      //       },
      //       {
      //         name: 'p',
      //         desc: '动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家动物园，马楼的家',
      //       },
      //     ],
      //   },
      //   {
      //     letter: 'Z',
      //     children: [
      //       {
      //         name: 'zoo',
      //         desc: '动物园，马楼的家',
      //       },
      //       {
      //         name: 'zoo(没有desc)',
      //       },
      //     ],
      //   },
      // ];
      $dts.dtsSearch.glossary
        .request({ keyword: keyword.value })
        .then((res) => {
          glossaryList.value = res.data;
        })
        .finally(() => {
          isLoadingFanish.value = true;
        });
    };

    const handleClose = () => {
      keyword.value = '';
      emit('update:show', false);
    };
    const search = throttle(getGlossaryList, 1000);
    onMounted(() => {
      getGlossaryList();
    });
    return () => (
      <>
        <NModal show={props.show} class={styles.glossary}>
          <NCard
            style={{ width: '7.51rem', height: '9.06rem' }}
            v-slots={{
              header: () => <Typography.H3>Glossary</Typography.H3>,
              default: () => (
                <>
                  <div class={styles.search}>
                    <div class={styles.text}>
                      <Typography.Text size={20} weight={400}>
                        Search
                      </Typography.Text>
                    </div>
                    <div class={styles.input}>
                      <NInput
                        v-model:value={keyword.value}
                        type="text"
                        placeholder="Term/Abbreviation"
                        onInput={search}
                        v-slots={{
                          suffix: () => {
                            return (
                              <div class={styles.suffix}>
                                <SVG.SearchSVG />
                              </div>
                            );
                          },
                        }}
                      />
                    </div>
                  </div>
                  <div class={styles.content}>
                    {/* <div class={styles.main}>
                      {glossaryList.value.map((item: any, index: any) => (
                        <div id={item.letter}>
                          <GlossaryItem letter={item.letter} children={item.children} key={index} />
                        </div>
                      ))}
                    </div>
                    <div class={styles.anchor}>
                   
                    <Anchor tableData={glossaryList.value} />
                    </div> */}
                    <div class={styles.main}>
                      {isLoadingFanish.value && (
                        <Anchor glossaryList={glossaryList.value} keyword={keyword.value} />
                      )}
                    </div>
                  </div>
                </>
              ),
            }}
            closable
            onClose={handleClose}
          />
        </NModal>
      </>
    );
  },
  props,
});
export default Glossary;
